/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import Immutable from "immutable";
import * as constants from "../constants/campaignList";
import { CLOSE_POPUP } from "../constants";

import { CampaignStat, Stat } from "../records/campaigns";
import adPopup from "./adPopup";
import dateRange from "./dateRange";
import updateDate from "./updateDate";
import { ON_LOAD_CONFIG } from "../constants/config";

const UPDATE_CONSTANTS = [
  constants.ON_CREATE_CAMPAIGN_SUCCESS,
  constants.ON_SAVE_CAMPAIGN_SUCCESS,
  constants.ON_SAVE_ADW_CAMPAIGN_SUCCESS,
  constants.ON_SET_CAMPAIGN_STATUS_SUCCESS
];

function campaigns(state = { objects: [], stat: {} }, action) {
  if (action.type == constants.ON_LOAD_CAMPAIGNS) {
    return {
      objects: new Immutable.List(action.campaignList.objects).map(
        c => new CampaignStat(c)
      ),
      stat: action.campaignList.stat
    };
  }
  return state;
}

const defaultStatState = new Immutable.Map({
  isOpen: false,
  daily: new Immutable.List(),
  summary: {},
  id: undefined,
  campaignName: undefined
});

function stat(state = defaultStatState, action) {
  if (action.type == constants.OPEN_STAT) {
    return state.merge({
      isOpen: true,
      campaignName: action.campaignName,
      id: action.id
    });
  }
  if (action.type == CLOSE_POPUP) {
    return defaultStatState;
  }
  if (action.type == constants.ON_LOAD_STAT) {
    const daily = new Immutable.List(action.stat.stat).map(st => new Stat(st));
    const summary = new Stat(action.stat.summary);
    return state.merge({ daily, summary });
  }
  return state;
}

const defaultAddFormSate = new Immutable.Map({
  isOpen: false,
  errors: {},
  fields: new Immutable.Map({}),
  enabled: false
});

function addForm(state = defaultAddFormSate, action) {
  if (action.type == constants.OPEN_CAMPAIGN_ADD_POPUP) {
    return state.set("isOpen", true);
  }
  if (action.type == CLOSE_POPUP) {
    return defaultAddFormSate;
  }
  if (action.type == constants.CHANGE_ADD_FORM_FIELD) {
    return state.mergeIn(["fields"], action.payload);
  }
  if (action.type == constants.ON_CREATE_CAMPAIGN_FAILD) {
    return state.set("errors", action.errors);
  }
  if (action.type == constants.ADD_FORM_SET_ENABLED) {
    return state.set("enabled", action.enabled);
  }
  return state;
}

const defaultEditFormState = new Immutable.Map({
  isOpen: false,
  id: undefined,
  errors: {},
  fields: new Immutable.Map({})
});

function editForm(state = defaultEditFormState, action) {
  if (action.type == constants.OPEN_SETTINGS) {
    return state.merge({ isOpen: true, id: action.id });
  }
  if (action.type == CLOSE_POPUP) {
    return defaultEditFormState;
  }
  if (action.type == constants.ON_LOAD_CAMPAIGN) {
    return state.set("fields", new Immutable.Map(action.campaign));
  }
  if (action.type == constants.SET_EDIT_FORM_FIELD) {
    return state.mergeIn(["fields"], action.payload);
  }
  if (action.type == constants.ON_SAVE_CAMPAIGN_FAILD) {
    return state.mergeIn(["errors"], action.errors);
  }
  return state;
}

const defaultSort = {
  key: "stat.clicks",
  order: "desc"
};

function dataSort(state = defaultSort, action) {
  if (
    action.type === ON_LOAD_CONFIG &&
    action.payload.CABINET_TYPE === "WEBMASTER"
  ) {
    return {
      key: "name",
      order: "asc"
    };
  }
  if (action.type == constants.SET_CAMPAIGN_TABLE_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

const defaultStatSort = {
  key: "date",
  order: "desc"
};

function campaignStatSort(state = defaultStatSort, action) {
  if (action.type == constants.SET_CAMPAIGN_STAT_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

export default combineReducers({
  campaigns,
  stat,
  addForm,
  editForm,
  dateRange: dateRange(constants.SET_CAMPAIGN_LIST_DATE_RANGE),
  dataSort,
  campaignStatSort,
  adPopup,
  updateDate: updateDate(UPDATE_CONSTANTS)
});
